import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=ca083f32&scoped=true&"
import script from "./CButton.vue?vue&type=script&lang=js&"
export * from "./CButton.vue?vue&type=script&lang=js&"
import style0 from "./CButton.vue?vue&type=style&index=0&id=ca083f32&lang=postcss&scoped=true&"
import style1 from "./CButton.vue?vue&type=style&index=1&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca083f32",
  null
  
)

export default component.exports